export default __webpack_public_path__ + "static/media/Gala-Mukomolova.8adb96d3.jpg";